<template>
  <b-sidebar
    id="sidebar-1"
    title="Emibit"
    backdrop-variant="info"
    backdrop
    shadow
    style="font-family: cerebriSansBold; background-color: white;"
  >
    <template v-slot:footer>
      <div
        class="d-flex align-items-center px-3 py-2"
        style="background-color: white; color: black;"
      >
        <strong class="mr-auto">Footer</strong>
      </div>
    </template>
    <div class="px-3 py-2 text-center" style="font-family: cerebriSansReg;">
      <b-img
        src="https://firebasestorage.googleapis.com/v0/b/vicus-d5b2b.appspot.com/o/menu_users%2Fk9HvzDNfeYQV6ZkOvgVwqM6w6jt1%2Flogo.jpg?alt=media&token=c65671c1-7b51-40c0-8d06-8f2ffec93711"
        fluid
        thumbnail
        style="max-height: 200px;"
      ></b-img>
      <b-list-group style="margin-top: 15px;">
        <template v-for="(item, index) in itemsCompany">
          <b-list-group-item
            href="#"
            :key="index"
            @click="navigateTo(item.link)"
            class="d-flex justify-content-between align-items-center"
            style="border: 0px;"
          >{{item.title}}</b-list-group-item>
        </template>

        <b-list-group-item
          href="#"
          @click="logout"
          class="d-flex justify-content-between align-items-center"
          style="border: 0px;"
        >Sign-Out</b-list-group-item>
      </b-list-group>
    </div>
  </b-sidebar>
</template>
<script>
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Menu",
  props: {
    msg: String
  },
  data() {
    return {
      itemsCompany: [
        {
          title: "Dashboard",
          link: "/app/dashboard"
        },
        {
          title: "Supervisor",
          link: "/app/dashboard"
        },
        {
          title: "Forms",
          link: "/app/forms"
        },
        {
          title: "Guard",
          link: "/app/guard"
        },
        {
          title: "Reports",
          link: "/app/dashboard"
        },
        {
          title: "Kiosk",
          link: "/app/kiosk"
        },
        {
          title: "Visit Monitor",
          link: "/app/visit-monitor"
        },
        {
          title: "Configuration",
          link: "/app/configuration"
        }
      ]
    };
  },
  methods: {
    navigateTo(link) {
      this.$router.push({ path: link });
    },
    logout: function(event) {
      self = this;
      firebase
        .auth()
        .signOut()
        .then(function() {
          // Sign-out successful.
          self.$router.push("/");
        })
        .catch(function(error) {
          null;
        });
    }
  }
};
</script>